import React from 'react'

const Footer = () => {
  return (
    <div className='bg-black mt-4 h-9'>
      <h1 className='text-[70%] text-center pt-[10px] text-white md:text-[100%] md:text-center md:pt-2'>Hak Cipta © 2024 Indihome Tangerang All rights reserved. </h1>
    </div>
  )
}

export default Footer